<template>
  <div class="incenters" style="margin-left: 0px;">
    <!-- style="border: 1px solid red;" -->
    
    <div>
      <Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增数据" fontSize="14px" @btnclick="addclick">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="删除选中项" fontSize="14px" @btnclick="delclick">
      </Commonbtn>
    </div>
    <div style="margin-left: 10px;">
      <!-- <Commonbtn title="导出"></Commonbtn> -->
      <div class="topstate" v-for="(item , index) of state" :key="index" :class="[{ 'ativte' : onchage == index}]" @click="tabClick(index)">
        {{ item.title }}
      </div>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div v-if="tableflag" style="overflow-x: scroll;">
      <Commontable @handleSelectionChange="handleSelectionChange" :rowhe="true" width="1000px" colnum=5 :tableData="tableDataDetail" :headerData="headerData" height="100%"></Commontable>
    </div>
    <div width="1000px" v-if="tableflags">
      <Commontable @handleSelectionChange="handleSelectionChanges" :rowhe="true" width="1000px" colnum=5 :tableData="tableDataDetailUnique" :headerData="headerData" height="100%"></Commontable>
    </div>

    <!-- style="border: 1px solid blue;" -->
    <div style="overflow-x: scroll;">

    </div>

    <DialogFrom width="1000px" title="选择商品" :dialogVisible="dialogVisibleSelectproduct" @cancel="cancelSelectproduct" @dialogOK="dialogOKcancelSelectproduct">
      <div class="from">
        <div class="inputtop" v-if="showorhide">
          <template v-for="(item , index) of fromdataadd">
            <Commondropdownlist ref="XZselect" @remoteMethodtows="remoteMethodtows" :loading="loading" :btx="item.btx" :key="index" :options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
          </template>
          <div style="display: inline-block;float: right;margin-right: 0px;">
            <CommonBtngroup checktitle="仅显示大于0" marginRight="590px" :chackbox="true" :show="showorhide" ref="btngroup" @showclick="showclick" @hide="hide" @select="select" @reset="reset" :qhide="true"></CommonBtngroup>
          </div>
          <div style="height:10px;">
          </div>

        </div>
        <div class="inputtops" v-else>
          <div style="display: inline-block;" v-for="(item , index) of fromdataadd.slice(0,2)" :key="index">
            <Commondropdownlist ref="XZselect" @remoteMethodtows="remoteMethodtows" :loading="loading" :minrigth="item.minrigth" :maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
          </div>
          <div style="display: inline-block;float: right;margin-right: 0px;">
            <CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
          </div>
          <div style="height:10px;">
          </div>
        </div>

        <div style="width: 970px;">
          <AddTable @changeTableSort="changeTableSortGoods" width="1000px"  :tableData="tableDatas" :headerData="headerData" height="100%">
          </AddTable>
        </div>
        <div class="pagination">
          <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
        </div>
      </div>
    </DialogFrom>
  </div>
</template>

<script>
import Commontable from '../../../../../components/common-table.vue'
import Commonbtn from '../../../../../components/common-btn.vue'
import DialogFrom from '../../../../../components/dialog-from.vue'
import CommonBtngroup from '../../../../../components/commongroup.vue'
import Commondropdownlist from '../../../../../components/common-dropdownlist.vue'
import Pagination from '../../../../../components/pagination.vue'
import AddTable from '../components/components/addTable.vue'
import addlistfrom from '../../fromData/addlistfrom'
import {
  WarehouseList,
  StockReportList,
  SaleBillDetail,
  SaleBillDetailUnique
} from '@/api/home'
export default {
  name: "InvAddDialogFromTable",
  components: {
    Commontable,
    Commonbtn,
    DialogFrom,
    CommonBtngroup,
    Commondropdownlist,
    AddTable,
    Pagination
  },
  props: {
    dpmid: {
      type: String,
      default: ""
    },
    state: {
      type: Array,
      default: []
    }
  },
  data: function () {

    return {
      fromdataadd: [],
      // state: [
      //   {
      //     title: '明细'
      //   },
      //   {
      //     title: '唯一码'
      //   }
      // ],
      tableflag: true,
      tableflags: false,
      dialogVisibleSelectproduct: false,
      showorhide: true,
      tableDatas: [],
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 120
      },
      {
        prop: 'InvAddCode',
        label: '存货代码',
        columnwidth: 180
      },
      {
        prop: 'InvName',
        label: '存货名称',
        columnwidth: 180
      },
      {
        prop: 'Batch',
        label: '批号',
        columnwidth: 180
      },
      {
        prop: 'ValiDate',
        label: '有效期至',
        columnwidth: 180
      },
      {
        prop: 'Quantity',
        label: '数量',
        columnwidth: 180
      },
      {
        prop: 'TaxUnitPrice',
        label: '含税单价',
        columnwidth: 220,
        // rowhe: true
      },
      {
        prop: 'TaxUnitPriceSum',
        label: '含税合计',
        columnwidth: 220,
        // rowhe: true
      },
      ],
      from: {
        whCode: "",
        invAddCode: "",
        batch: "",
      },
      onchage: 0,
      tableflag: true,
      tableflags: false,
      pageSize: 20,
      PageIndex: 1,
      total: null,
      loading: true,
      tableDataDetail: [],
      tableDataDetailUnique: [],
    }
  },
  created() {
  },
  mounted() {
    this.SaleBillDetail()
    this.fromdataadd = JSON.parse(JSON.stringify(addlistfrom))
  },
  methods: { 
    changeTableSortGoods(colnum){
      console.log(colnum);
    },
    // 明细
    async SaleBillDetail() {
      let {
        data,
        code
      } = await SaleBillDetail({
        dpmid: this.dpmid
      })
      if (code == 0) {
        this.tableDataDetail = data
      }
    },
    // 唯一码
    async SaleBillDetailUnique() {
      let {
        data,
        code
      } = await SaleBillDetailUnique({
        dpmid: this.dpmid
      })
      if (code == 0) {
        this.tableDataDetailUnique = data
      }
    },
    tabClick(index) {
      if (index == 0) {
        this.tableflag = true
        this.tableflags = false
        this.SaleBillDetail()
      }
      if (index == 1) {
        this.tableflag = false
        this.tableflags = true
        this.SaleBillDetailUnique()
      }
      if (this.onchage != index) {
        this.onchage = index
      }
      this.$emit('clicktab', index)
    },
    // 仓库远程搜索
    async remoteMethodtows(query) {
      this.loading = true
      let {
        data,
        code
      } = await WarehouseList({
        whCode: query
      })
      if (code == 0) {
        this.loading = false
        this.fromdataadd[0].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.WHCode,
            value: item.WHName
          }
          this.fromdataadd[0].options.push(obj)
        })
      }
    },
    // 产品库列表
    async stockReportList() {

      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        data,
        code
      } = await StockReportList({
        whCode: this.from.whCode,
        invAddCode: this.from.invAddCode,
        batch: this.from.batch,
        isAboveZero: 1,
        PageSize: this.PageSize,
        PageIndex: this.PageIndex
      })
      if (code == 0) {
        this.total = data.Count
        this.tableDatas = data.data
        loading.close();
      } else {
        loading.close();
      }
    },
  

    showclick() {
      this.showorhide = true
    },
    hide() {
      this.showorhide = false
      //console.log("askdas", this.showorhide)

    },
    addclick() {
      this.dialogVisibleSelectproduct = true
      this.stockReportList()
      this.$emit('addclick')
    },
    delclick() {

    },
    select() {
      this.from.whCode = this.$refs.XZselect[0].modelvalue
      this.from.invAddCode = this.$refs.XZselect[1].modelvalue
      this.from.batch = this.$refs.XZselect[2].modelvalue
      this.stockReportList()
    },
    reset() {
      this.$refs.XZselect.map((item, index) => {
        item.modelvalue = ''
      })
    },
    cancelSelectproduct() {
      this.dialogVisibleSelectproduct = false
    },
    dialogOKcancelSelectproduct() {
      this.dialogVisibleSelectproduct = false
    },
    handleCurrentChange(pageindex) {
      this.PageIndex = pageindex
      this.stockReportList()
      //console.log(pageindex, 'pageindex')
    },
    handleSizeChange(paegSzie) {
      this.PageSize = paegSzie
      this.stockReportList()
    },
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
    },
    handleSelectionChanges(val) {
      this.$emit('handleSelectionChanges', val)
    },
  }
}
</script>

<style lang="less" scoped>
.ativte {
  border: 1px solid red;
  color: #e71d43;
  background-color: #fce8ec;
  transition: 0.2s linear;
}

.incenters {
  height: 100%;
  font-family: "微软雅黑";
  background-color: #fff;
  width: 980px;
  margin-top: 10px;
  padding-bottom: 10px;
  padding-top: 2px;

  div {
    margin-right: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    // width: 100%;
  }
}

.topstate {
  width: 100px;
  height: 32px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
}
.from {
  width: 100%;
  .inputtop {
    width: 960px;
    height: 40px;
    // box-shadow: 0px 1px 4px 0px rgba(56, 43, 43, 0.1);
    border-bottom: 1px solid #f0f0f0;
    background-color: #ffffff;
    padding-top: 15px;
    padding-bottom: 70px;
    animation: shows 0.2s linear;
    overflow: hidden;
  }

  .inputtops {
    width: 960px;
    height: 0;
    // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid #f0f0f0;
    background-color: #ffffff;
    padding-top: 15px;
    padding-bottom: 70px;
    overflow: hidden;
    // animation: hides 0.5s ease-in;
  }
}
@keyframes shows {
  0% {
    height: 0px;
  }
  100% {
    height: 40px;
  }
}
@keyframes hides {
  0% {
    opacity: 0;
    height: 40px;
  }
  100% {
    opacity: 1;
    height: 0px;
  }
}
</style>
